module.exports = __webpack_public_path__ + "img/open-15_3month01.5fb4f1b9.png";